import { injectable } from 'inversify';

import {
  InfoTemplateResponse,
  EventTypeItem,
  TemplatePlaceholder,
} from '@app/gen/templates';

import { TemplateInformation } from '../../types';

@injectable()
export class SettingsTemplateUploadTransformMapper {
  private getEventsType(eventTypes: EventTypeItem[]) {
    return eventTypes.map((item) => item.name).join(', ');
  }

  private getPossibleFiles(placeholders: TemplatePlaceholder[]) {
    return placeholders.map((item) => {
      return {
        placeholder: item.placeholder,
        label: item.label,
      };
    });
  }

  public transform(template: InfoTemplateResponse): TemplateInformation {
    return {
      companyName: template.company.name,
      name: template.name,
      eventsType: this.getEventsType(template?.event_types),
      possibleFieldsDinamic: this.getPossibleFiles(
        template?.placeholders.filter((placeholder) => !placeholder.is_generic),
      ),
      possibleFieldsStatic: this.getPossibleFiles(
        template?.placeholders.filter((placeholder) => placeholder.is_generic),
      ),
    };
  }
}
